var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTransactionsImg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.858,
    height: 20,
    viewBox: "0 0 22.858 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.285)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10,129.421v-1.429H1.429A1.431,1.431,0,0,0,0,129.421v2.857H10.3A12.791,12.791,0,0,1,10,129.421Z",
    transform: "translate(0 -127.992)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.428)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.8,287.992a12.849,12.849,0,0,1-4.589,4,2.147,2.147,0,0,1-2.13,0,12.914,12.914,0,0,1-4.59-4H0v7.143a1.43,1.43,0,0,0,1.429,1.429h20a1.429,1.429,0,0,0,1.429-1.429v-7.143H22.8ZM6.429,292.278H3.572a.714.714,0,0,1,0-1.429H6.429a.714.714,0,0,1,0,1.429Z",
    transform: "translate(0 -287.992)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.429)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M267,34.209l-5-2.143a.717.717,0,0,0-.564,0l-5,2.143a.712.712,0,0,0-.432.656v2.857c0,3.93,1.453,6.227,5.359,8.477a.718.718,0,0,0,.711,0c3.906-2.244,5.359-4.542,5.359-8.477V34.865A.712.712,0,0,0,267,34.209Zm-2.58,3.246-2.857,3.572a.722.722,0,0,1-.559.267h-.03a.717.717,0,0,1-.564-.317l-1.429-2.143a.714.714,0,0,1,1.189-.791l.887,1.33,2.246-2.809a.715.715,0,0,1,1.117.891Z",
    transform: "translate(-256 -32.008)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransactionsImg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/transactionsImg.8cda282b.svg";
export { ForwardRef as ReactComponent };